import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/eTrack/quoteApproval/initialState.quoteApproval.data';

const ETrackQuoteApproval = createSlice({
  name: 'eTrackQuoteApproval',
  initialState,
  reducers: {
    setResetAllValues: () => initialState,
    setSearchParams: (state, action) => {
      state.searchParams[action?.payload?.key] = action?.payload?.value;
    },
    setSearchResult: (state, action) => {
      state.searchResult = action?.payload?.quotes || [];
      state.searchResult = state.searchResult?.sort((a, b) => new Date(b.dateSubmitted) - new Date(a.dateSubmitted))
      state.totalQuotesRecords = action?.payload?.totalRecords || 0;
    },
    setQuoteDetails: (state, action) => {
      state.quoteDetail = action?.payload ? action?.payload : null;
    },
    resetValues: (state) => {
      state.searchParams = initialState.searchParams;
      state.searchResult = initialState.searchResult;
    },
    setETrackEntitlementSelectedData: (state, action) => {
      state.eTrackEntitlementSelectedData = action?.payload;
    },
  },
});

export const {
  setSearchParams,
  setSearchResult,
  setQuoteDetails,
  resetValues,
  setResetAllValues,
  setETrackEntitlementSelectedData,
} = ETrackQuoteApproval.actions;
export default ETrackQuoteApproval.reducer;
